import { Avatar, Button, Space } from "antd";
import { Fragment } from "react";
import { Link, useParams } from "react-router-dom";
import AVATAR_IMG from "../../../../assets/images/empty_user.jpg";
import CardTitle from "../../../../components/common/CardTitle";
import CustomCard from "../../../../components/common/CustomCard";
import Loader from "../../../../components/ui/Loader";
import {
  useGetProjectsByUserQuery,
} from "../../../../features/portal/Products/productsApi";
import { useGetSingleUserQuery } from "../../../../features/portal/user/userApi";
import useError from "../../../../hooks/useError";
import SidebarLayout from "../../../../layouts/SidebarLayout";

const backLink = "/admin/user-access-permission/user-list";

export default function UserDetailsPermission() {
  const { id } = useParams();
  const {
    data: userData,
    isLoading: isUserLoading,
    isError: isUserError,
    error: userError,
  } = useGetSingleUserQuery(String(id), {
    skip: !id,
  });
  useError(isUserError, userError, "User fetch fail");
  const {
    data: userProjectData,
    isLoading: isUserProjectLoading,
    isError: isUserProjectError,
    error: userProjectError,
  } = useGetProjectsByUserQuery(
    {
      params: { userid: id },
    },
    {
      skip: !id,
    }
  );
  useError(isUserProjectError, userProjectError, "Get group data fail");

  const userDetails = userData?.data;
  const groupPermissions = userProjectData?.data || [];

  return (
    <SidebarLayout title="User Details and Logs">
      {isUserLoading || isUserProjectLoading ? (
        <Loader />
      ) : (
        <CustomCard className="p-6">
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <CardTitle>User Info</CardTitle>

              <div className="flex items-center gap-4 min-h-[150px]">
                <Avatar
                  className="w-24 h-24 rounded-full"
                  src={userDetails?.photo || AVATAR_IMG}
                />

                <div className="flex-1">
                  <h5 className="text-slate-700 text-lg font-semibold leading-8">
                    {userDetails?.name}
                  </h5>
                  <p className="text-slate-600 text-sm font-medium leading-6">
                    {userDetails?.sub_department?.name}
                  </p>
                  <p className="text-slate-600 text-sm font-medium leading-6">
                    Department of{" "}
                    <span className="text-yellow-500">
                      {userDetails?.department?.name}
                    </span>
                  </p>
                  <p className="text-slate-600 text-sm font-medium leading-6">
                    Email:{" "}
                    <a
                      href={`mailto:${userDetails?.email}`}
                      className="!text-accent"
                    >
                      {userDetails?.email}
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <div>
              <CardTitle>Assigned Role</CardTitle>

              <div className="grid grid-cols-12 gap-x-4 gap-y-2 mt-4">
                {groupPermissions?.map((el) => (
                  <Fragment key={`${el?.project?.id}-${el?.role?.id}`}>
                    <div className="text-blue-600 text-sm font-medium leading-6 col-span-4">
                      {el?.project?.name}
                    </div>
                    <div className="text-zinc-700 text-sm font-medium leading-6  col-span-8">
                      {el?.role?.roleName}
                    </div>
                    {/* <div className="flex items-center">
                      <Button
                        type="text"
                        className="!p-0 !size-8 flex justify-center items-center !text-red-500"
                        htmlType="button"
                        //   onClick={() => handleEdit(el, idx)}
                      >
                        <DeleteIcon />
                      </Button>
                    </div> */}
                  </Fragment>
                ))}
              </div>
            </div>
          </div>

          <Space className="w-full mt-4" size={12}>
            <Link to={backLink}>
              <Button className="normal-dark-button modal-button" size="middle">
                Cancel
              </Button>
            </Link>
            <Link to={`/admin/user-access-permission/user-list/edit/${id}`}>
              <Button className="modal-button" type="primary" size="middle">
                Edit
              </Button>
            </Link>
          </Space>
        </CustomCard>
      )}
    </SidebarLayout>
  );
}
